import React from 'react'
import styles from '../Proj1Folder/Proj1.module.css'
import alunile11 from '../../Images/aalunile1.jpeg'
import alunile12 from '../../Images/aalunile2.jpeg'
import alunile13 from '../../Images/aalunile3.jpeg'
import alunile14 from '../../Images/aalunile4.jpeg'
import alunile15 from '../../Images/aalunile5.jpeg'
import alunile16 from '../../Images/aalunile6.jpeg'
import alunile17 from '../../Images/aalunile7.jpeg'
import alunile18 from '../../Images/aalunile8.jpeg'
import alunile19 from '../../Images/aalunile9.jpeg'
import alunile20 from '../../Images/aalunile10.jpeg'
import alunile21 from '../../Images/aalunile21.jpeg'
import alunile22 from '../../Images/aalunile22.jpeg'
import alunile23 from '../../Images/aalunile23.jpeg'
import alunile24 from '../../Images/aalunile24.jpeg'
import alunilep from '../../Images/sadatfac.jpg'
import alunile1 from '../../Images/alunile1.png'
import alunile2 from '../../Images/alunile2.png'
import alunile3 from '../../Images/alunile3.png'





export default function Alunile() {
  return (

    <>
        <div className="container my-5 py-5">
          <div className="row  align-items-center">
            <div className="col-md-6">
                <h3 className={`${styles.color} my-3`}> Alunile Factory  ​</h3>
                <p> Project description: : Administrative and production building in Sadat City </p>
                <p>Type of contract: Design </p>
                <p> Area:  21748 m2</p>
                <p>Owner Name : Alunile </p>
                <p>Type of works : Architectural , civil & electromechanical  </p>
            </div>
            <div className="col-md-6">
                <img src={alunilep} alt="achegy" className='img-fluid'/>
            </div>   
          </div>
          <div className="row my-5 pb-5">

                <div className="col-md-4 my-1 text-center">
               <img src={alunile11} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
                <div className="col-md-4 my-1 text-center">
               <img src={alunile12} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
                <div className="col-md-4 my-1 text-center">
               <img src={alunile13} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
                <div className="col-md-4 my-1 text-center">
               <img src={alunile14} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
                <div className="col-md-4 my-1 text-center">
               <img src={alunile15} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
                <div className="col-md-4 my-1 text-center">
               <img src={alunile16} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
                <div className="col-md-4 my-1 text-center">
               <img src={alunile17} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
                <div className="col-md-4 my-1 text-center">
               <img src={alunile18} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
                <div className="col-md-4 my-1 text-center">
               <img src={alunile19} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
                <div className="col-md-4 my-1 text-center">
               <img src={alunile20} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
                       <div className="col-md-4 my-1 text-center">
               <img src={alunile21} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
                       <div className="col-md-4 my-1 text-center">
               <img src={alunile22} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
                       <div className="col-md-4 my-1 text-center">
               <img src={alunile23} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
                       <div className="col-md-4 my-1 text-center">
               <img src={alunile24} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
                      <div className="col-md-4 my-1 text-center">
               <img src={alunile1} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
            <div className="col-md-4 my-1 text-center">
               <img src={alunile2} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>
            <div className="col-md-4 my-1 text-center">
               <img src={alunile3} alt="achegy" className={`${styles.imgSizeProj}`}/> 
            </div>


            
          </div>
     
        </div>

    </>
  )
}
